<strong>
    <ap-content key="klant.digicodeHerstel.username.current"></ap-content>
</strong>
<p>{{ username }}</p>
@if (changeUsername) {
    <p>
        <ap-content key="klant.digicodeHerstel.usernameAndPassword.text"></ap-content>
    </p>
}
@if (!changeUsername) {
    <p>
        <ap-content key="klant.digicodeHerstel.password.text"></ap-content>
    </p>
}
@if (changeUsername) {
    <form [formGroup]="usernameForm" autocomplete="off" class="ap-display-block ap-margin-bottom-4">
        <strong>
            <ap-content key="klant.digicodeHerstel.username.title"></ap-content>
        </strong>
        <ap-input
            data-bb="newUsername"
            [formControl]="usernameForm.controls.newUsername | apFormControl"
            [label]="'klant.digicodeHerstel.username.new' | apContent"
            [messages]="errorMessagesNewUserName"
        ></ap-input>
    </form>
}
<form [formGroup]="passwordForm" autocomplete="off">
    <strong>
        @if (changeUsername) {
            <ap-content key="klant.digicodeHerstel.password.subTitle"></ap-content>
        }
    </strong>
    <ap-password-input
        data-bb="currentPassword"
        [formControl]="passwordForm.controls.currentPassword | apFormControl"
        [label]="'klant.digicodeHerstel.password.current' | apContent"
        [messages]="errorMessagesCurrentPassword"
    >
    </ap-password-input>
    <ap-password-input
        data-bb="newPassword"
        [formControl]="passwordForm.controls.newPassword | apFormControl"
        [label]="'klant.digicodeHerstel.password.new' | apContent"
        [messages]="errorMessagesNewPassword"
    >
    </ap-password-input>
    <ap-content type="info" [key]="'klant.digicodeHerstel.password.explanation'"> </ap-content>
    <div class="ap-display-block ap-margin-bottom-4">
        <ap-password-input
            data-bb="validatePassword"
            [formControl]="passwordForm.controls.validatePassword | apFormControl"
            [label]="'klant.digicodeHerstel.password.new2' | apContent"
            [messages]="errorMessagesValidatePassword"
        >
        </ap-password-input>
    </div>
</form>
<div class="ap-display-block ap-margin-bottom-4">
    <ap-button type="submit" variant="primary" (onClick)="sendCredentials()" data-bb="save" [isDisabled]="buttonIsDisabled">
        <ap-submit-text
            [isLoading]="buttonIsDisabled"
            [submitText]="'klant.digicodeHerstel.submit' | apContent"
            [loadingText]="'klant.digicodeHerstel.loadingText' | apContent"
        ></ap-submit-text>
    </ap-button>
    <ap-button type="button" variant="secondary" (onClick)="cancel()" data-bb="cancel">
        {{ 'klant.digicodeHerstel.cancel' | apContent }}
    </ap-button>
</div>
